/*------------------------------------*\
	#TOOLTIP
\*------------------------------------*/

const tooltip = '.js-tooltip',
	tooltipList = document.querySelectorAll(tooltip);

const initTooltip = () => {

	if (tooltipList) {
		tooltipList.forEach(tooltip => {

			tooltip.addEventListener('click', () => {
				tooltipList.forEach(tooltip => {
					tooltip.classList.remove('is-open');
				});
				tooltip.classList.add('is-open');
			});

			document.addEventListener('click', function (event) {
				if (event.target.closest('.js-tooltip-close')) {
					tooltipList.forEach(tooltip => {
						if (tooltip.classList.contains('is-open')) {
							tooltip.classList.remove('is-open');
							tooltip.classList.add('is-closed');

							event.target.closest('.js-tooltip-close').onmouseout = function () {
								tooltipList.forEach(tooltip => {
									tooltip.classList.remove('is-closed');
								});
							}
						}
					});
				} else if (event.target.closest('.js-tooltip')) {
					return false;
				} else {
					tooltipList.forEach(tooltip => {
						tooltip.classList.remove('is-open');
					});
				}
			});

		});
	}
};

window.addEventListener('DOMContentLoaded', (event) => {
	initTooltip();
});
